<template>
  <div class="hba1cView">
    <mu-paper class="insetGraph">
      <mu-tabs v-model="selectedTab">
        <mu-tab value="bloodGlucose" @click.native="goTo('BloodGlucoseProgress')">
          {{$t('message.cardBloodGlucose')}}
        </mu-tab>
        <mu-tab value="hba1c">
          {{$t('message.cardHbA1c')}}
        </mu-tab>
      </mu-tabs>
      <hba1c-line-graph v-if="$store.state.user.scope" :userId="$store.state.user.scope.user_id"></hba1c-line-graph>
    </mu-paper>
    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50" width="100">
        <hba1c-input
          style="margin-top: 24px;"
          v-if="$store.state.user.settings"
          :hba1c="$store.state.user.settings.hba1c"
          class="bottom">
        </hba1c-input>
        <blood-glucose-input
          class="card-spacing bottom"
          v-if="$store.state.user.settings"
          :hba1c="$store.state.user.settings.hba1c"
          :bloodGlucose="$store.state.user.settings.blood_glucose"
        ></blood-glucose-input>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" v-if="titleIndex === 0" class="timelineSpacing">
                <div class="bold timelineTitle"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :key="'tl-' + index"
                  iconLine="8"
                  iconType="solid"
                  :iconColor="btnColor"
                  @click.native="showItemControls(item)"
                >
                  <mu-row>
                    <mu-col>
                      <div class="trackingDate" v-if="!item.isEditMode"
                           v-text="groupedItemDate(item.date_created)"></div>
                    </mu-col>
                    <mu-col>
                      <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}"
                           class="reading"
                           v-text="hba1cSetting.measure === 'mmol-mol' ? '' +item.mmol_mol + ' mmol/mol' :  item.percent + ' %'"></div>
                    </mu-col>
                  </mu-row>
                  <div v-if="item.isControlsVisible && !item.isEditMode" align="right">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <hba1c-edit
                      :item="item"
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                    ></hba1c-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div>{{$t('message.loadingText')}}</div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import HbA1cApi from '../../api/Tracking/HbA1c'
  import BgLineGraph from "../../components/Tracking/Graphs/BloodGlucose/LineGraph";
  import BloodGlucoseInput from "../../components/Tracking/Input/BloodGlucose/BloodGlucose";
  import BgEdit from "../../components/Tracking/Edit/BloodGlucose/BloodGlucoseEdit.vue";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import Hba1cInput from "../../components/Tracking/Input/HbA1c/HbA1c";
  import Hba1cLineGraph from "../../components/Tracking/Graphs/Hba1c/LineGraph.vue";
  import Hba1cEdit from "../../components/Tracking/Edit/HbA1c/HbA1cEdit";


  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    components: {
      Hba1cEdit,
      Hba1cLineGraph,
      Hba1cInput,
      TrackingExporter,
      TrackingNotifier,
      BgEdit,
      BloodGlucoseInput,
      BgLineGraph
    },
    mixins: [TrackingDetailMixin],
    data() {
      let self = this;
      return {
        btnColor: '#E84341',
        bgSettings: {},
        selectedTab: "hba1c"
      }
    },
    mounted() {
      let self = this;

      self.$gtag.pageview('/tracking/hba1c');


      HbA1cApi.getHbA1cTrackingDetail(1, 15)
        .then(function (response) {
          self.data = response.data;
          self.isReadingsLoading = false;
        });


      self.$EventBus.$on('bgPusherReceived', function () {
        self.isReadingsLoading = true;
        HbA1cApi.getHbA1cTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          })
      });

    },
    methods: {
      goTo(name) {
        let self = this;
        self.$router.push({
          name: name
        })
      },
      updateReading(data) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return reading.progress_id === data.progress_id
        })[0];

        currentReading.percent = data.percent;
        currentReading.mmol_mol = data.mmol_mol;
        currentReading.date_created = data.date_created;

        self.$emit('updateGraphData');

        self.sortItems();
      },
      deleteReading(reading) {


        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveHbA1cItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return HbA1cApi.deleteHbA1cReading(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveHbA1cItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })
          }.bind(self))
          .catch(self.$alert.noop)
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          HbA1cApi.getHbA1cTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      }
    },
    computed: {
      hba1cSetting() {
        let self = this;
        return self.$store.state.user.settings.hba1c;
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('bgReadingAdded');
      this.$EventBus.$off('bgPusherReceived');
    }
  }
</script>
<style lang="less" scoped>
  @import "./styles/trackingDetail.css";
  @bgBranding: #E84341;
  .hba1cView {
    .timelineSpacing {
      padding-top: 8px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0px;
    }
    .timelineSpacing.notEditMode:hover {
      background: fade(@bgBranding, 10%);
      cursor: pointer;
    }

    .no_tags {
      opacity: 0.7;
      font-size: 16px;
      line-height: 1.5;
      color: #9b9b9b;
    }

    @hyper: #E74C3C;
    @inRange: #8DC948;
    @hypo: #0179d5;

    .inRange {
      color: @inRange;
    }
    .hypo {
      color: @hypo;
    }
    .hyper {
      color: @hyper;
    }
    .bold {
      font-weight: bold;
    }
    #blood-glucose-data .tagGroup .tag {
      padding-left: 8px;
      color: initial !important;
      font-weight: normal;
    }
    #blood-glucose-data .tagGroup .tag img {
      padding-right: 8px;
      font-weight: normal;
    }
    .whiteTitle {
      font-size: 18px !important;
      color: white !important;
    }
    .reading {
      font-size: 16px;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */
    {
      transform: translateX(10px);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// HbA1c.vue?9853dcf2